import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Else, If, Then } from '@edikk-edikk/if';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useAdvertContactsState, useAdvertContactsVisibleControl } from '#advertContacts/hooks';
import { useMenuActionControlProviderContext, useMenuState } from '#baseMenu/hooks';

const AdvertContactsToggleButton: FC = () => {
  const { isLoadInProcess } = useAdvertContactsState();
  const { isActionsBlocked } = useMenuState();
  const { isOpen, open, hide } = useAdvertContactsVisibleControl();
  const { menuActionControl } = useMenuActionControlProviderContext();

  const handlerClick = useCallback(() => {
    if (isOpen) {
      hide();
      menuActionControl.remove('advertContact');
    } else {
      menuActionControl.hide().then(() => {
        open();
        menuActionControl.add({ id: 'advertContact', hide });
      });
    }
  }, [hide, isOpen, menuActionControl, open]);

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      pill
      textUppercase
      onClick={handlerClick}
      additionalClassName="flex-grow-1"
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader
        isLoading={isLoadInProcess}
        content={(
          <If condition={isOpen}>
            <Then>
              <FormattedMessage defaultMessage="Close" />
            </Then>
            <Else>
              <FormattedMessage defaultMessage="Contacts" />
            </Else>
          </If>
        )}
      />
    </Button>
  );
};

export { AdvertContactsToggleButton };
